export default class NotFoundError extends Error {
  notFoundError = true
  resourceType: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(resourceType: string, ...args: any[]) {
    super(`Resource ${resourceType} not found.`, ...args)
    this.resourceType = resourceType
  }
}
